<template>
  <preloader-component v-if="loading" />
  <ErrorsComponent v-show="isThereErrorComponent" />
  <admin-panel-component
    v-if="roles === 'admin' && !loading"
    @setClient="setClient"
  />
  <div v-if="!loading" class="home">
    <h1>
      <span>Здравствуйте, </span> <span>{{ names }} </span>
    </h1>
    <h2 v-if="roles === 'admin' && is_client">
      <span>{{ `Вы работаете под ${cli_names}` }}</span>
    </h2>
    <p v-if="emptyData">Договоров не найдено</p>
    <div v-if="need_pay" class="alert alert-danger">У вас есть неоплаченые счета</div>
    <div class="home__groupPolicies">
      <div v-for="(group, key) in groups" :key="key" class="home__groupPolicy">
        <div class="home__groupPolicyHeader">{{ group.title }}</div>
        <div class="home__groupPolicyList">
          <div v-for="(contract, ckey) in group.contracts" :key="ckey" class="home__policy">
            <a @click.prevent="goToContract(key, ckey)" :href="'/profile/contract/' + contract.agreement_id">
              <h5 class="home__policyHeader">{{ contract.head }}</h5>
              <div class="home__policyGroupData">
                <div class="home__policyGroupDataHeader">{{ contract.strategy.title }}</div>
                <div class="home__policyGroupDataValue">{{ contract.strategy.value }}</div>
              </div>
              <div class="home__policyGroupData">
                <div class="home__policyGroupDataHeader">{{ contract.begin_date.title }}</div>
                <div class="home__policyGroupDataValue">{{ contract.begin_date.value }}</div>
              </div>
              <div class="home__policyGroupData">
                <div class="home__policyGroupDataHeader">{{ contract.end_date.title }}</div>
                <div class="home__policyGroupDataValue">{{ contract.end_date.value }}</div>
              </div>
              <div class="home__moreInfo">Подробнее</div>
            </a>
            <span v-if="contract.pay == 1" class="home__btn btn btn-outline-danger">
              <a :href="contract.purl">Оплатить</a>
            </span>
          </div>
        </div>
      </div>
      <div v-if="iszCheck()" class="home__groupPolicy">
        <div class="home__groupPolicyHeader">Оценка результатов тестирования</div>
        <p style="margin-bottom: 0; color:rgb(0, 117, 212); font-size: 16px">Положительная оценка результата
          тестирования</p>
      </div>
    </div>
  </div>
</template>

<script>
import PreloaderComponent from "@/profile/components/PreloaderComponent.vue";
import AdminPanelComponent from "@/profile/components/AdminPanelComponent.vue";
import ErrorsComponent from "@/profile/components/ErrorsComponent.vue";

export default {
  // eslint-disable-next-line
  name: "ContractsView",
  data: () => {
    return {
      names: "",
      is_client: true,
      cli_names: "",
      groups: {},
      need_pay: false,
      errors: [],
      loading: true,
      roles: "",
      emptyData: false,
    };
  },
  computed: {
    newIsz() {
      const x = this.groups?.isz?.contracts;

      return x ? x.filter(item => {
        const beginDate = new Date(item.begin_date.value.split(".").reverse().join("-"));
        return beginDate >= new Date("2024-10-01"); // 1 октября или позже
      }) : [];
    },
    isThereErrorComponent() {
      return this.$myApp.errors && !this.loading ? true : false;
    }
  },
  mounted() {
    this.$myApp.auth.set(false);
    this.$myApp.name.on((value) => {
      this.names = value;
    });
    this.$myApp.client.on((value) => {
      this.cli_names = value;
    });
    this.$myApp.role.on((value) => {
      this.roles = value;
    });
    this.getContractsList();
  },
  methods: {
    setClient() {
      this.loading = true;
      this.getContractsList();
    },
    async getContractsList() {
      let params = {
        action: "get-contracts-list",
        object: "cpa",
        token: this.$myApp.token.get()
      };
      this.$myApp.actions.set(params.action);
      let api = await this.$api2.get(params);
      this.$myApp.actions.pullout(params.action);

      if (api.success) {
        this.loading = false;
        if (api.data.list.length === 0) {
          // this.$myApp.errors.set("Договоров не найдено");
          this.emptyData = true;
        } else {
          this.emptyData = false;
          this.$myApp.errors.reset();
          this.groups = api.data.list;
          if (api.data.list.length === 0 && api.data.menu.afc === 1) {
            this.$router.push({ name: "constructor" });
          }
          for (let [value] of Object.entries(api.data.list)) {
            if (value.pay === 1) {
              this.need_pay = true;
            }
          }
        }
        if (api.data.menu) {
          this.$myApp.menu.set(api.data.menu);
        }
        if (api.data.roles) {
          this.$myApp.role.set(api.data.roles);
        }
        if (api.data.names) {
          this.$myApp.name.set(
            api.data.names.first_name + " " + api.data.names.last_name
          );
        }
        if (api.data.client) {
          if (api.data.client.length > 0) {
            if (api.data.names.id === api.data.client.id) {
              this.is_client = false;
            }
          }
          this.$myApp.client.set(
            api.data.client.first_name + " " + api.data.client.last_name
          );
        }
      }
      if (api.error) {
        if (api.error_code === 8026) {
          this.$myApp.auth.set(true);
          this.$router.push("changepass");
        }
        this.$myApp.errors.set(api.errors);
      }

      // console.log(api);
    },
    goToContract(gkey, key) {
      this.$myApp.contract.set(this.groups[gkey].contracts[key]);
      this.$router.push({ name: "contract", params: { id: this.groups[gkey].contracts[key].agreement_id } });
    },
    iszCheck() {
      if (this.newIsz.length > 0 && this.newIsz.find(el => Number(el.ins_amount_ru) < 1400000)) {
        return true;
      } else {
        return false;
      }
    }
  },
  components: {
    AdminPanelComponent,
    PreloaderComponent,
    ErrorsComponent
  }
};
</script>

<style>
.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb
}

.alert-danger hr {
  border-top-color: #f1b0b7
}

.alert {
  position: relative;
  padding: .75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: .25rem
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: .375rem .75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: .25rem;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media screen and (prefers-reduced-motion: reduce) {
  .btn {
    transition: none
  }
}

.btn:focus, .btn:hover {
  text-decoration: none
}

.btn.focus, .btn:focus {
  outline: 0;
  box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.btn.disabled, .btn:disabled {
  opacity: .65
}

.btn:not(:disabled):not(.disabled) {
  cursor: pointer
}

a.btn.disabled, fieldset:disabled a.btn {
  pointer-events: none
}

.btn-outline-danger {
  color: #dc3545;
  background-color: transparent;
  background-image: none;
  border-color: #dc3545
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545
}

.btn-outline-danger.focus, .btn-outline-danger:focus {
  box-shadow: 0 0 0 .2rem rgba(220, 53, 69, .5)
}

.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #dc3545;
  background-color: transparent
}

.btn-outline-danger:not(:disabled):not(.disabled).active, .btn-outline-danger:not(:disabled):not(.disabled):active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545
}

.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 .2rem rgba(220, 53, 69, .5)
}
</style>
